import type { StoreSettings } from '@/types'

/** Fields safe to expose on the public storefront (no admin or secret config). */
export const PUBLIC_STORE_SETTING_KEYS = [
  'storeName',
  'tagline',
  'email',
  'phone',
  'whatsapp',
  'instagram',
  'address',
  'shippingCharge',
  'freeShippingThreshold',
  'premiumPackagingEnabled',
  'premiumPackagingCharge',
  'premiumPackagingDescription',
  'codEnabled',
  'razorpayEnabled',
  'razorpayEnvironment',
  'razorpayKeyId',
  'razorpayDevKeyId',
  'razorpayProdKeyId',
  'currency',
  'returnRefundPolicy',
  'termsAndConditions',
  'privacyPolicy',
  'comingSoonEnabled',
  'comingSoonLaunchAt',
  'comingSoonProgressStartAt',
  'showCategoriesOnHomepage',
  'returnWindowHours',
  'returnWindowMinutes',
] as const satisfies readonly (keyof StoreSettings)[]

export function pickPublicStoreSettings(
  store: Partial<StoreSettings>
): Partial<StoreSettings> {
  const out: Partial<StoreSettings> = { id: 'public' }
  for (const key of PUBLIC_STORE_SETTING_KEYS) {
    if (store[key] !== undefined) {
      ;(out as Record<string, unknown>)[key] = store[key]
    }
  }
  return out
}
